import { render, staticRenderFns } from "./MyBasics.vue?vue&type=template&id=2f860dee&scoped=true&"
import script from "./MyBasics.vue?vue&type=script&lang=js&"
export * from "./MyBasics.vue?vue&type=script&lang=js&"
import style0 from "./MyBasics.vue?vue&type=style&index=0&id=2f860dee&lang=less&scoped=true&"
import style1 from "./MyBasics.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f860dee",
  null
  
)

export default component.exports